/// <reference path="../../apps/typings/customTds.d.ts"/>

import { AppUtils } from '../../shared/utils/index';
import { BasicApplicationUrlBuilder } from "./BasicApplicationUrlBuilder";


declare const moment: any;
export class UploadApiService<T extends BasicAppDefinition> {
	private readonly options: BasicAppOptions<T>;
	private readonly applicationUrlBuilder: BasicApplicationUrlBuilder<T>;

	constructor(options: BasicAppOptions<T>) {
		this.options = options;
		this.applicationUrlBuilder = new BasicApplicationUrlBuilder(this.options);
	}

	public getVorgangsnummer(formId: string,
		successCallback: (data: ApiResponse<string>) => void,
		errorCallback: () => void): void {
		AppUtils.Ajax.fragment({
			method: 'GET',
			url: AppUtils.Url.updateUrlParameter({ FormId: formId }, this.applicationUrlBuilder.fullUrl(this.options.app.apivorgangsnummer)),
		}, successCallback, errorCallback);
	}

	public fileUpload(inputElemId: string,
		arrayBuffer: FormData,
		vorgangsnummer: string,
		purpose: string,
		successCallback: (data: ApiResponse<string>, elemId: string) => void,
		errorCallback: () => void): void {

		const uploadStartTime = moment();
		AppUtils.Ajax.fragment({
			method: 'POST',
			url: AppUtils.Url.updateUrlParameter({ purpose: purpose, processId: vorgangsnummer }, this.applicationUrlBuilder.fullUrl(this.options.app.apiupload)),
			data: arrayBuffer,
			async: true,
			cache: false,
			contentType: false,
			processData: false
		}, (data: ApiResponse<string>) => {
			T.Utils.Logger.log(`Upload Success after ${moment().diff(uploadStartTime)}`);
			successCallback(data, inputElemId);
		}, (e) => {
			T.Utils.Logger.log(`Upload Error after ${moment().diff(uploadStartTime)}`, e.responseJSON.Messages);
			errorCallback();
		}, 60000);
	}
}
